import axios from '@utils/axios';
import router from '@router/router';

const customerDetail = {
  state: {
    customerId: 0,
    address: {},
    gender: 1,
    email: '',
    name: '',
    surname: '',
    extID: '',
    openLimsID: '',
    agreedToDataProcessing: false,
    agreedToTermsOfService: false,
    phone: { prefix: '', number: '' },
    categories: [],
    audit: [],
    reservationStatus: '',
    DNAAgreementDigital: true,
    DNASampleUsageStatus: 0,
    agreedToSampleBeingUsedForScientificPurposes: false,
    agreedToSampleExamination: false,
    registrationSource: 0,
    notifyByEmail: false,
    notifyBySms: false
  },
  mutations: {
    setCustomerId(state, id) {
      state.customerId = id;
    },
    setAddress(state, address) {
      state.address = address;
    },
    setGender(state, gender) {
      state.gender = gender;
    },
    setEmail(state, email) {
      state.email = email;
    },
    setName(state, name) {
      state.name = name;
    },
    setSurname(state, surname) {
      state.surname = surname;
    },
    setExtID(state, id) {
      state.extID = id;
    },
    setOpenLimsID(state, id) {
      state.openLimsID = id;
    },
    setAgreedToDataProcessing(state, val) {
      state.agreedToDataProcessing = val;
    },
    setAgreedToTermsOfService(state, val) {
      state.agreedToTermsOfService = val;
    },
    setPhone(state, phone) {
      state.phone = phone;
    },
    setCategories(state, categories) {
      state.categories = categories;
    },
    setAudit(state, audit) {
      state.audit = audit;
    },
    setReservationStatus(state, status) {
      state.reservationStatus = status;
    },
    setDNAAgreementDigital(state, digital) {
      state.DNAAgreementDigital = digital;
    },
    setAgreedToSampleBeingUsedForScientificPurposes(state, purposes) {
      state.agreedToSampleBeingUsedForScientificPurposes = purposes;
    },
    setAgreedToSampleExamination(state, exam) {
      state.agreedToSampleExamination = exam;
    },
    setDNASampleUsageStatus(state, status) {
      state.DNASampleUsageStatus = status;
    },
    setRegistrationSource(state, source) {
      state.registrationSource = source;
    },
    setNotifyByEmail(state, val) {
      state.notifyByEmail = val;
    },
    setNotifyBySms(state, val) {
      state.notifyBySms = val;
    }
  },
  actions: {
    fetchCustomer(context) {
      return axios.get('admin/customers/customer', {
        params: {
          CustomerId: context.state.customerId
        }
      })
        .then((res) => {
          if (res.status === 404) {
            router.push({ name: 'admin.customers.view' });
          } else if (res.status === 200) {
            context.commit('setAddress', res.data.result.address);
            context.commit('setGender', res.data.result.gender);
            context.commit('setEmail', res.data.result.email);
            context.commit('setName', res.data.result.name);
            context.commit('setSurname', res.data.result.surname);
            context.commit('setExtID', res.data.result.extID);
            context.commit('setOpenLimsID', res.data.result.openLimsID);
            context.commit('setAgreedToDataProcessing', res.data.result.agreedToDataProcessing);
            context.commit('setAgreedToTermsOfService', res.data.result.agreedToTermsOfService);
            context.commit('setPhone', res.data.result.phone);
            context.commit('setDNAAgreementDigital', res.data.result.dnaAgreementWasDigital);
            context.commit('setDNASampleUsageStatus', res.data.result.dnaSampleUsageStatus || 0);
            context.commit('setAgreedToSampleBeingUsedForScientificPurposes', res.data.result.agreedToSampleBeingUsedForScientificPurposes);
            context.commit('setAgreedToSampleExamination', res.data.result.agreedToSampleExamination);
            context.commit('setReservationStatus', res.data.result.reservationStatus);
            context.commit('setRegistrationSource', res.data.result.registrationSource);
            context.commit('setNotifyByEmail', res.data.result.notifyByEmail);
            context.commit('setNotifyBySms', res.data.result.notifyBySms);
            Promise.resolve(true);
          }
        }).catch(() => {
          router.push({ name: 'admin.dashboard' });
        });
    },
    fetchCategories(context) {
      return axios.get('admin/customers/customercategories', {
        params: {
          CustomerId: context.state.customerId
        }
      })
        .then((res) => {
          context.commit('setCategories', res.data.result);
        });
    },
    fetchAudit(context) {
      return axios.get('admin/customers/customeraudit', {
        params: {
          Id: context.state.customerId
        }
      }).then((res) => {
        context.commit('setAudit', res.data.result);
      });
    },
    resetContext(context) {
      context.commit('setCustomerId', 0);
      context.commit('setAddress', {});
      context.commit('setGender', 1);
      context.commit('setEmail', '');
      context.commit('setName', '');
      context.commit('setSurname', '');
      context.commit('setExtID', '');
      context.commit('setOpenLimsID', '');
      context.commit('setAgreedToDataProcessing', false);
      context.commit('setAgreedToTermsOfService', false);
      context.commit('setDNAAgreementDigital', true);
      context.commit('setDNASampleUsageStatus', 0);
      context.commit('setAgreedToSampleBeingUsedForScientificPurposes', false);
      context.commit('setAgreedToSampleExamination', false);
      context.commit('setPhone', { prefix: '', number: '' });
      context.commit('setCategories', []);
      context.commit('setRegistrationSource', 0);
      context.commit('setNotifyByEmail', false);
      context.commit('setNotifyBySms', false);
    }
  },
  namespaced: true
};

export default customerDetail;
